export { default as List } from 'groups/containers/GroupsListContainer';
export { default as Form } from 'groups/containers/GroupFormContainer';



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/containers/index.js